/* eslint-disable react/prefer-es6-class, react/sort-comp, quote-props, arrow-body-style */
import classNames from 'classnames';
import React from 'react';
import ProgressBar from 'es6/components/common/progress-bar';
import { t } from 'es6/services/localization';

export default React.createClass({

  displayName: 'ItemPreview',

  propTypes: {
    disabled: React.PropTypes.bool,
    itemPackages: React.PropTypes.array,
    onSkipped: React.PropTypes.func.isRequired,
    skippedItemIds: React.PropTypes.array,
  },

  getInitialState() {
    return {
      skippedItemIds: [],
    };
  },

  getDefaultProps() {
    return {
      disabled: false,
      itemPackages: [],
      onSkipped: null,
      skippedItemIds: [],
    };
  },

  componentWillMount() {
    if (this.props.skippedItemIds.length > 0) {
      this.setState({ skippedItemIds: this.props.skippedItemIds });
    }
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.skippedItemIds) {
      this.setState({ skippedItemIds: nextProps.skippedItemIds });
    }
  },

  _handleSkipped(itemPackage) {
    if (this.props.disabled) {
      return;
    }

    const skippedItemIds = this.state.skippedItemIds;
    const index = skippedItemIds.indexOf(itemPackage.getId());

    if (index !== -1) {
      skippedItemIds.splice(index, 1);
    } else {
      skippedItemIds.push(itemPackage.getId());
    }

    this.setState({ skippedItemIds });

    // Send the skipped items back to the properties callback.
    if (this.props.onSkipped) {
      this.props.onSkipped.call(this, skippedItemIds);
    }
  },

  render() {
    const className = classNames('items-session-details', {
      'items-unavailable': !this.props.itemPackages.length,
      'disabled': this.props.disabled,
    });

    // Split rows into two columns.
    const rows = _.chain(this.props.itemPackages)
      .groupBy((elem, i) => { return Math.floor(i / 2); })
      .toArray()
      .value();

    const actionMessage = this.props.itemPackages.length > 0 ?
      t('review your items, then hit start.') :
      t('no new items.');

    return (
      <section className={className}>
        <h4 className="action-message">{actionMessage}</h4>

        <section className="items-container">
          <section className="items">
            {rows.map((itemPackages, i) => { return this._renderItemRow(itemPackages, i); })}
          </section>
        </section>
      </section>
    );
  },

  /**
   * Populates an item row, will add an extra slot if one isn't available.
   */
  _renderItemRow(itemPackages, rowNum) {
    let emptyItemSlot = null;

    if (itemPackages.length !== 2) {
      emptyItemSlot = (<section className="item" />);
    }

    return (
      <section key={rowNum} className="item-row">
        {itemPackages.map((itemPackage) => { return this._renderItem(itemPackage); })}
        {emptyItemSlot}
      </section>
    );
  },

  _renderItem(itemPackage) {
    const isSkipped = this.state.skippedItemIds.indexOf(itemPackage.getId()) !== -1;
    let itemClass = classNames('item', { 'skipped': isSkipped });
    let title = isSkipped ? t('unskip-item') : t('skip-item');
    let onSkipClick = this._handleSkipped.bind(this, itemPackage);

    return (
      <section className={itemClass} key={itemPackage.getId()}>
        <div className="item-actions">
          {this._renderNewOrProgressBar(itemPackage)}
          <span className="glyph glyph-remove" title={title} onClick={onSkipClick}></span>
        </div>

        <div className="item-details">
          <p className="cue text">{itemPackage.getText()}</p>
          {this._renderTransliteration(itemPackage)}
          {this._renderResponse(itemPackage)}
        </div>
      </section>
    );
  },

  // If the item has a memory, show the progress bar.
  _renderNewOrProgressBar(itemPackage) {
    if (!itemPackage.memory) {
      return (
        <span className="new-label">{t('js_iknow.new item')}</span>
      );
    }

    return (
      <ProgressBar progress={itemPackage.memory.progress} showProgressTag className="progress-bar-item" />
    );
  },

  // If the item is not new, don't show anything.
  _renderResponse(itemPackage) {
    if (itemPackage.memory) {
      return null;
    }

    return (
      <p className="response">{itemPackage.getTranslation()}</p>
    );
  },

  // If the item is a review or doesn't have a transliteration, don't show anything.
  _renderTransliteration(itemPackage) {
    let transliteration = itemPackage.getTransliteration();

    if (itemPackage.memory || !transliteration) {
      return null;
    }

    return (
      <p className="transliteration">{transliteration}</p>
    );
  },
});
